<template>
  <div class="add-office-dialog">
    <page-dialog @changeDialogVisible="changeDialogVisible" :dialogVisible="dialogVisible" title="新增职位"
      @handleSaveClick="handleSaveClick" :isShowFooter="true">
      <el-form ref="ruleFormRef" :model="ruleForm" :rules="rules" label-width="80px" label-position="left"
        class="demo-ruleForm">
        <el-form-item label="岗位名称:" prop="name">
          <el-input placeholder="岗位名称" v-model="ruleForm.office" maxlength="10" ></el-input>
        </el-form-item>
      </el-form>
    </page-dialog>
  </div>
</template>

<script lang="js">
import { defineComponent, reactive, ref } from 'vue'
import PageDialog from '@/components/page-dialog/page-dialog.vue'
import { useStore } from 'vuex'
import { COMPANY_ID } from '@/common/constant'

export default defineComponent({
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  components: {
    PageDialog
  },
  emits: ['changeDialogVisible'],
  setup(props, { emit }) {
    const store = useStore()
    const ruleForm = reactive({
      office: ''
    })
    const changeDialogVisible = (flag) => {
      emit('changeDialogVisible', flag)
    }

    const handleSaveClick = () => {
      store.dispatch('staff/addStaffRankAction', [COMPANY_ID, ruleForm.office])
    }

    return {
      changeDialogVisible,
      ruleForm,
      COMPANY_ID,
      handleSaveClick
    }

  }
})
</script>

<style scoped lang="less">
.add-rank-dialog {
  &:deep(.el-select) {
    width: 100%;
  }
}
</style>








